import API from "./api";
import sender from "./sender";

class MaDB {
  get ma() {
    return "/ma/";
  }
  post(method, body, headers = {}) {
    // console.log("MaDB post", method, body);
    const path = `${this.ma}${method}`;
    return sender.restPost(path, body, headers).then(response => {
      if (response.error) {
        show(response.error, null);
        throw Error(response.error);
      }
      return response.data;
    });
  }
  signin(login, password) {
    const method = "basic_auth/signin";
    const body = { login, password };
    return this.post(method, body).then(data => data.result);
  }
  signout() {
    const method = "basic_auth/signout";
    return this.post(method).then(data => data.result);
  }
  get_user() {
    const method = "get_user";
    return this.post(method).then(data => data.result);
  }
  get_objects(refs) {
    const method = "get_objects";
    const body = { list: refs };
    return this.post(method, body).then(data => data.result);
  }
  search(text, type, backlist, limit = 100, skip = 0, visible = undefined) {
    const method = "search";
    const body = { text, type, backlist, limit, skip, visible };
    return this.post(method, body).then(data => data.result);
  }
  save(diff, is_new) {
    const method = "save";
    const body = { diff, is_new };
    return this.post(method, body).then(data => data.obj);
  }
  json_get(body) {
    const method = "json_get";
    return this.post(method, body);
  }
  send(path, body, cfg = {}) {
    if (!cfg.prefix) return API.sqlr.post(path, body);
    // crutch
    if (path.indexOf("/api") == 0) path = path.replace("/api", "");
    path = `api/${path}`;
    return API.http.post(path, body).then(response => response.data);
  }
  bind_plugin(ref, pref) {
    const method = "bind_plugin";
    const body = { ref, pref };
    return this.post(method, body);
  }
  remove(ref, is_removed) {
    const method = "remove";
    const body = { ref, is_removed };
    return this.post(method, body);
  }
}

export default new MaDB();
